import { Grid, Card, CardContent, Button, Typography, Icon } from '@mui/material'

import { Plus, TrendingUp } from 'react-feather'
import { useFechInitCreditsApplies } from './hooks';
import { useLocation, useParams } from 'react-router-dom';
import { AllowedAccess } from 'react-permission-role';
import { CreditsForm } from './CreditsForm/CreditsForm';
import { CreditsTable } from './CreditsTable/CreditsTable';
import { AdminExpenses } from './Expenses/Expenses';
import { ModalModule } from './CreditsForm/Modal';

export const AdminCredits = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitCreditsApplies({ location, paramsURL })

  const {
    globalStates,
  } = useFetchInit

  const { showForm, showExpenses } = globalStates

  return (
    // <VehicleAppliesProvider >
    <AllowedAccess permissions={['237_CREDITOS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {!(showForm || showExpenses) && (
          <div className='panel-body' id='listadoregistros'>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card>
                  <CardContent >
                    <ModalModule useFetchInit={useFetchInit} />

                    <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mt: 1, mb: 3 }}>

                      <Typography variant='h4' sx={{ display: 'flex', alignItems: 'center' }}>
                        Admin - Creditos
                        <Icon component={TrendingUp} sx={{ ml: 1, fontSize: '1.5rem' }} />
                      </Typography>

                    </Grid>
                    <div className="pt-4"></div>

                    <CreditsTable
                      useFetchInit={useFetchInit}
                    />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        )}
        {(showForm) && (
          <>
            <div className='panel-body' id='formularioregistros'>
              <CreditsForm
                useFetchInit={useFetchInit}
              />
            </div>
          </>
        )}
        {(showExpenses) && (
          <>
            <div className='panel-body' style={{ height: '100%', overflow: 'hidden' }} >
              <AdminExpenses
                useFetchInit={useFetchInit}
              />
            </div>
          </>
        )}
      </div>
    </AllowedAccess>

  )
}
